import { HTTP } from "@/utils/http-common"
export default {
  markAsRead: function($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/notifications/mark-as-read/${id}/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  list: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/notifications/all_list/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
